import UIHoverCardController from "controllers/ui/hover-card_controller";
import { createPopper } from "@popperjs/core";

export default class UITooltipController extends UIHoverCardController {
  static targets = ["content", "wrapper", "trigger", "arrow"];

  connect() {
    // Create popper instance with arrow modifier
    this.popperInstance = createPopper(this.triggerTarget, this.contentTarget, {
      placement: this.contentTarget.dataset.side || "top",
      modifiers: [
        {
          name: "offset",
          options: {
            offset: [0, 8],
          },
        },
        {
          name: "arrow",
          options: {
            element: this.arrowTarget,
            padding: 8,
          },
        },
      ],
    });

    // Store bound functions for proper cleanup
    this.boundHandleMouseEnter = this.handleMouseEnter.bind(this);
    this.boundHandleMouseLeave = this.handleMouseLeave.bind(this);

    // Bind event listeners for mouse interactions
    this.triggerTarget.addEventListener("mouseenter", this.boundHandleMouseEnter);
    this.triggerTarget.addEventListener("mouseleave", this.boundHandleMouseLeave);

    // Add keyboard accessibility
    this.triggerTarget.addEventListener("focus", this.boundHandleMouseEnter);
    this.triggerTarget.addEventListener("blur", this.boundHandleMouseLeave);
  }

  disconnect() {
    // Clean up event listeners
    this.triggerTarget.removeEventListener("mouseenter", this.boundHandleMouseEnter);
    this.triggerTarget.removeEventListener("mouseleave", this.boundHandleMouseLeave);
    this.triggerTarget.removeEventListener("focus", this.boundHandleMouseEnter);
    this.triggerTarget.removeEventListener("blur", this.boundHandleMouseLeave);

    // Destroy popper instance
    if (this.popperInstance) {
      this.popperInstance.destroy();
    }
  }

  handleMouseEnter() {
    this.mouseEnter();
  }

  handleMouseLeave() {
    this.mouseLeave();
  }
}
